import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["trigger", "content", "input", "card", "grid", "emptyState", "query"];

  show() {
    this.triggerTarget.classList.add("d-none");
    this.contentTarget.classList.remove("d-none");
  }

  search() {
    var value = this.inputTarget.value.trim();
    var terms = value.toLowerCase().split(/\s+/).filter(Boolean);
    var hasSearch = terms.length > 0;

    if (this.hasQueryTarget) {
      this.queryTarget.textContent = '"' + value + '"';
    }

    this.gridTarget.style.gridTemplateColumns = hasSearch ? "repeat(auto-fill, minmax(min(100%, 320px), 500px))" : "repeat(auto-fit, minmax(min(100%, 320px), 1fr))";
    this.gridTarget.style.justifyContent = hasSearch ? "start" : "stretch";

    var visibleCount = 0;

    this.cardTargets.forEach(function(card) {
      var haystack = card.dataset.searchText || "";
      var matches = terms.every(function(term) {
        return haystack.indexOf(term) !== -1;
      });

      if (matches) {
        visibleCount++;
        card.classList.remove("d-none");
        card.classList.add("d-flex");
      } else {
        card.classList.remove("d-flex");
        card.classList.add("d-none");
      }
    });

    this.emptyStateTarget.classList.toggle("d-none", !hasSearch || visibleCount > 0);
  }
}
